import React, { FC } from 'react';
import { ReactComponent as LogoIcon } from 'application/assets/logo.svg';
import { LoaderStyled } from './styles';
import { useTranslation } from 'react-i18next';

interface LoaderProps {
  text?: string;
}

/**
 * A loader component that displays a logo icon and an optional text label.
 *
 * @param props - The properties for the component.
 * @returns The JSX element for the component.
 */
const Loader: FC<LoaderProps> = ({ text }) => {
  const { t } = useTranslation();
  return (
    <LoaderStyled>
      <div>
        <LogoIcon />
      </div>
      <h1>
        {t('global.loader')}
        <br />
        {text}
      </h1>
    </LoaderStyled>
  );
};

export default Loader;
